export interface TaxonomyItem {
  id: string;
  label?: string;
  description?: string;
  lineage?: string;
  parent_id?: string;
  type?: string;
  has_children?: boolean;
  isSummary?: boolean;
}

export interface ReplacePsycoWithLifestyleOptions {
  label?: string;
  description?: string;
  psychographicType?: string;
  /** When true, keeps the original item description (workspace base taxonomy). */
  omitDescription?: boolean;
}
